import React from 'react'
import PropTypes from 'prop-types'
import { LocalizedNumber, PolynomialCoeff, Columns } from 'src/components'
import styles from './Polynomial.scss'

const Polynomial = ({ coefficients, precision }) =>
  !coefficients.length ? (
    '-'
  ) : (
    <Columns className={styles.equation} gap="0" layout="auto">
      <span className={styles.y}>y =</span>
      {coefficients
        .map((coefficient = 0, i) => (
          <PolynomialCoeff
            key={i}
            sign={coefficient >= 0 ? (i !== coefficients.length - 1 ? '+' : '') : '-'}
            degree={i}
          >
            <LocalizedNumber value={Math.abs(coefficient)} maximumSignificantDigits={precision + 1} />
          </PolynomialCoeff>
        ))
        .reverse()}
    </Columns>
  )

Polynomial.defaultProps = {
  coefficients: [],
  precision: 6,
}

Polynomial.propTypes = {
  coefficients: PropTypes.arrayOf(PropTypes.node),
  precision: PropTypes.number,
}

export default Polynomial
